import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "../../../environments/environment";
import { CONSTANTS } from "../constants/constants";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DocumentService {
  constructor(private readonly http: HttpClient) {}

  headers = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  public getDocument(
    poolId: number,
    year: number,
    documentCategoryID: string = "RC001",
    pageIndex: number = 1,
    pageZise: number = 999
  ) {
    const url = environment.BASE_API_URL + CONSTANTS.API.DOCUMENT.OPS_CIRCULARS;

    const params = {
      poolId: poolId.toString(),
      year: year.toString(),
      documentCategoryID: documentCategoryID,
      pageIndex: pageIndex.toString(),
      PageSize: pageZise.toString(),
    };

    return this.http.get<any>(url, { ...this.headers, params });
  }

  public getOpsCirculars(
    poolId: number,
    DocumentCategoryID: string = "RC004",
    PageIndex: number = 1,
    PageZise: number = 999
  ) {
    const url = environment.BASE_API_URL + CONSTANTS.API.DOCUMENT.OPS_CIRCULARS;
    return this.http
      .get<any>(url, {
        ...this.headers,
        params: {
          PoolId: poolId.toString(),
          DocumentCategoryID: DocumentCategoryID,
          PageSize: PageZise.toString(),
          PageIndex: PageIndex.toString(),
        },
      })
      .pipe(
        map((res) => {
          res.result.data = res.result.data ?? [];
          return res;
        })
      );
  }

  public getLegalUpdates() {
    let url = environment.BASE_API_URL + CONSTANTS.API.DOCUMENT.LEGAL_UPDATES;
    return this.http.get<any>(url, this.headers);
  }

  public getDownloadDocument(documentId: string): Observable<any> {
    let url = environment.BASE_API_URL + CONSTANTS.API.DOCUMENT.DOCUMENT;
    return this.http.get(url, {
      ...this.headers,
      params: { documentId: documentId },
      responseType: "blob",
    });
  }
}
